<template>
<main class="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
    <h1 class="text-md tracking-tight text-gray-900">Shopping Cart</h1>

    <form class="mt-12 lg:grid lg:grid-cols-12 lg:gap-x-12 lg:items-start xl:gap-x-16" v-if="cart.line_items && cart.line_items.length">
        <section aria-labelledby="cart-heading" class="lg:col-span-7">
            <h2 id="cart-heading" class="sr-only">Items in your shopping cart</h2>

            <ul role="list" class="border-t border-b border-gray-200 divide-y divide-gray-200">
                <CartItem v-for="lineItem in cart.line_items" :key="lineItem.id" class="cart__inner" :item="lineItem" @update-quantity="handleUpdateQuantity" @remove-from-cart="$emit('remove-from-cart', $event)" />
            </ul>
        </section>

        <!-- Order summary -->
        <section aria-labelledby="summary-heading" class="mt-16 bg-gray-50 rounded-lg px-4 py-6 sm:p-6 lg:p-8 lg:mt-0 lg:col-span-5">
            <h2 id="summary-heading" class="text-lg font-medium text-gray-900">Order summary</h2>

            <dl class="mt-6 space-y-4">
                <div class="flex items-center justify-between">
                    <dt class="text-sm text-gray-600">Subtotal</dt>
                    <dd class="text-sm font-medium text-gray-900">{{ cart.subtotal.formatted_with_symbol }}</dd>
                </div>
                <!-- <div class="border-t border-gray-200 pt-4 flex items-center justify-between">
                    <dt class="flex items-center text-sm text-gray-600">
                        <span>Shipping estimate</span>
                        <a href="#" class="ml-2 flex-shrink-0 text-gray-400 hover:text-gray-500">
                            <span class="sr-only">Learn more about how shipping is calculated</span>
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </dt>
                    <dd class="text-sm font-medium text-gray-900">$5.00</dd>
                </div>
                <div class="border-t border-gray-200 pt-4 flex items-center justify-between">
                    <dt class="flex text-sm text-gray-600">
                        <span>Tax estimate</span>
                        <a href="#" class="ml-2 flex-shrink-0 text-gray-400 hover:text-gray-500">
                            <span class="sr-only">Learn more about how tax is calculated</span>
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </dt>
                    <dd class="text-sm font-medium text-gray-900">$8.32</dd>
                </div>
                <div class="border-t border-gray-200 pt-4 flex items-center justify-between">
                    <dt class="text-base font-medium text-gray-900">Order total</dt>
                    <dd class="text-base font-medium text-gray-900">$112.32</dd>
                </div> -->
            </dl>

            <div class="mt-6">
                <button @click="checkout" type="button" class="w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500">Checkout</button>
                <button type="button" class="my-2 w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500" @click="emptyCart">
                    Empty cart
                </button>
                <button type="button" class="w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500" @click="emptyCart">
                    Continue shopping
                </button>
            </div>
        </section>
    </form>
    <p v-else>You have no items in your shopping cart, start adding some!</p>
</main>
</template>

<script>
import CartItem from './CartItem';

export default {
    name: 'Cart',
    components: {
        CartItem,
    },
    props: ['cart'],
    methods: {
        /**
         * Updates line_items in cart
         * https://commercejs.com/docs/sdk/cart/#update-cart
         *
         * @param {string} lineItemId ID of the cart line item being updated
         * @param {number} quantity New line item quantity to update
         */
        handleUpdateQuantity(lineItemId, quantity) {
            this.$commerce.cart.update(lineItemId, {
                quantity
            }).then((resp) => {
                this.$emit('refresh-cart');
            }).catch((error) => {
                console.log('There was an error updating the cart items', error);
            });
        },
        /**
         * Empty the entire cart
         * https://commercejs.com/docs/sdk/cart#empty-cart
         */
        emptyCart() {
            this.$emit('empty-cart');
        },
        /**
         * Navigate to checkout and close cart
         */
        checkout() {
            this.$emit('checkout');
        },
    }
}
</script>
